import { SelectableBox } from '@coolblue-development/next-patterns/client';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const StyledInsuranceSelectableBox = styled(SelectableBox, {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  label {
    grid-column: span 12;
    gap: 0;

    li {
      margin-top: 0;
    }
  }

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    label {
      grid-column: span 6;
      grid-template-rows: subgrid;
      grid-row: ${({ numberOfProducts }) => (numberOfProducts === 1 ? ' span 4' : '1 / span 4')};
    }
  }

  ${({ theme }) => theme.breakpoint.minWidth('lg')} {
    label {
      grid-column: span 4;
      grid-template-rows: subgrid;
      grid-row: span 4;
    }
  }
`;
//# sourceMappingURL=InsuranceSelectableBox.styled.js.map